import React from 'react';
import { userAppData } from '../MainApp.js';
import './SysManagerDesktop.css';
import './SysManagerMobile.css';
import { Outlet, useNavigate } from "react-router-dom";

import { BsCalendarFill } from 'react-icons/bs';
import { BsCalendar2WeekFill } from 'react-icons/bs';
import { FaPerson } from "react-icons/fa6";
import { FaChildren } from "react-icons/fa6";
import { IoDocuments } from 'react-icons/io5';
import { GrDocumentVerified } from 'react-icons/gr';
import { FaAddressBook, FaBell, FaCog, FaTools, FaWpforms } from 'react-icons/fa';
import Header from '../common/header.js';

function hasSysManagerAccessFlag(value) {
    return value === true;
}

function SysManagerHomeMenuLearnersButton() {
    const navigate = useNavigate();

    return (
        <div className='sysManager_Home_Button' onClick={() => navigate('/app/sysmanager/learners')}>
            <FaChildren color='#706f6f' size={120} />
            <h1>Learners</h1>
        </div>
    )
};

function SysManagerHomeMenuStaffButton() {

    let navigate = useNavigate();

    return (
        <div className='sysManager_Home_Button' onClick={(() => navigate("/app/sysmanager/staff"))}>
            <FaPerson color='#706f6f' size={120} />
            <h1>Staff</h1>
        </div>
    )
};

/** Opens the parent and carer contacts area for authorised users. */
function SysManagerHomeMenuContactsButton() {
    const navigate = useNavigate();
    return (
        <div className='sysManager_Home_Button' onClick={() => navigate('/app/sysmanager/contacts')}>
            <FaAddressBook color='#706f6f' size={120} />
            <h1>Contacts</h1>
        </div>
    );
}

function SysManagerHomeMenuBookingsButton() {

    let navigate = useNavigate();

    return (
        <div className='sysManager_Home_Button' onClick={(() => navigate("/app/sysmanager/bookings"))}>
            <BsCalendarFill color='#706f6f' size={120} />
            <h1>Bookings</h1>
        </div>
    )
};

function SysManagerHomeMenuRotasButton() {

    let navigate = useNavigate();

    return (
        <div className='sysManager_Home_Button' onClick={(() => navigate("/app/sysmanager/rotas"))}>
            <BsCalendar2WeekFill color='#706f6f' size={120} />
            <h1>Rotas</h1>
        </div>
    )
};

function SysManagerHomeMenuReprographicsButton() {

    let navigate = useNavigate();

    return (
        <div className='sysManager_Home_Button' onClick={(() => navigate("/app/sysmanager/reprographics"))}>
            <IoDocuments color='#706f6f' size={120} />
            <h1>Reprographics</h1>
        </div>
    )
};

function SysManagerHomeMenuPerformanceManagementButton() {
    const navigate = useNavigate();
    return (
        <div className='sysManager_Home_Button' onClick={() => navigate('/app/sysmanager/performance-management')}>
            <GrDocumentVerified color='#706f6f' size={120} />
            <h1>Performance Management</h1>
        </div>
    );
}

/** Opens the Forms administration area for authorised System Manager users. */
function SysManagerHomeMenuFormsButton() {
    const navigate = useNavigate();
    return (
        <div className='sysManager_Home_Button' onClick={() => navigate('/app/sysmanager/forms')}>
            <FaWpforms color='#706f6f' size={120} />
            <h1>Forms</h1>
        </div>
    );
}

/** Opens the OnCall settings area for authorised System Manager users. */
function SysManagerHomeMenuOnCallButton() {
    const navigate = useNavigate();
    return (
        <div className='sysManager_Home_Button' onClick={() => navigate('/app/sysmanager/oncall')}>
            <FaBell color='#706f6f' size={120} />
            <h1>OnCall</h1>
        </div>
    );
}

/** Opens the Tools administration area for authorised System Manager users. */
function SysManagerHomeMenuToolsButton() {
    const navigate = useNavigate();
    return (
        <div className='sysManager_Home_Button' onClick={() => navigate('/app/sysmanager/tools')}>
            <FaTools color='#706f6f' size={120} />
            <h1>Tools</h1>
        </div>
    );
}

/** Opens school-wide General Settings for authorised System Manager users. */
function SysManagerHomeMenuGeneralSettingsButton() {
    const navigate = useNavigate();
    return (
        <div className='sysManager_Home_Button' onClick={() => navigate('/app/sysmanager/general-settings')}>
            <FaCog color='#706f6f' size={120} />
            <h1>General Settings</h1>
        </div>
    );
}

export function SysManagerHomeIndex() {
    const sysManagerPerms = userAppData["sysManager"] || {};
    const canManageLearners = hasSysManagerAccessFlag(sysManagerPerms.learnerAdmin);
    const canManageStaff = hasSysManagerAccessFlag(sysManagerPerms.staffAdmin);
    const canManageContacts = hasSysManagerAccessFlag(sysManagerPerms.contactsAdmin);
    const canManageBookings = hasSysManagerAccessFlag(sysManagerPerms.bookingsAdmin);
    const canManageRotas = hasSysManagerAccessFlag(sysManagerPerms.rotaAdmin);
    const canManageReprographics = hasSysManagerAccessFlag(sysManagerPerms.reproAdmin);
    const canManagePerformance = hasSysManagerAccessFlag(sysManagerPerms.performanceManagementAdmin);
    const canManageForms = hasSysManagerAccessFlag(sysManagerPerms.forms);
    const canManageTools = Number(sysManagerPerms.perms ?? 0) === 1 && hasSysManagerAccessFlag(sysManagerPerms.toolsAdmin);
    const canManageGeneralSettings = Number(sysManagerPerms.perms ?? 0) === 1 && hasSysManagerAccessFlag(sysManagerPerms.generalAdmin);
    const canManageOnCall = hasSysManagerAccessFlag(sysManagerPerms.onCallAdmin);
    const hasVisibleAdminAreas = (
        canManageLearners ||
        canManageStaff ||
        canManageContacts ||
        canManageBookings ||
        canManageRotas ||
        canManageReprographics ||
        canManagePerformance ||
        canManageForms ||
        canManageOnCall ||
        canManageGeneralSettings ||
        canManageTools
    );

    return (
        <div className='main_div'>
            <div className='internal_main_div sysManager_home_container'>
                <Header title='System Manager' />

                <div className='sysManager_main_div'>
                   {canManageBookings && <SysManagerHomeMenuBookingsButton />}

                   {canManageContacts && <SysManagerHomeMenuContactsButton />}

                   {canManageForms && <SysManagerHomeMenuFormsButton />}

                   {canManageGeneralSettings && <SysManagerHomeMenuGeneralSettingsButton />}

                   {canManageLearners && <SysManagerHomeMenuLearnersButton />}

                   {canManageOnCall && <SysManagerHomeMenuOnCallButton />}

                   {canManagePerformance && <SysManagerHomeMenuPerformanceManagementButton />}

                   {canManageReprographics && <SysManagerHomeMenuReprographicsButton />}

                   {canManageRotas && <SysManagerHomeMenuRotasButton />}

                   {canManageStaff && <SysManagerHomeMenuStaffButton />}

                   {canManageTools && <SysManagerHomeMenuToolsButton />}

                   {!hasVisibleAdminAreas && (
                        <div className='sysManager_Home_Button sysManager_Home_Button--static'>
                            <h1>No Admin Areas Enabled</h1>
                        </div>
                   )}
                </div>
            </div>
        </div>

    )
};

export default function SysManagerHomeLayout() {

    let navigate = useNavigate();

    const sysManagerUser = Number(userAppData?.sysManager?.perms ?? 0);

    if (sysManagerUser == 0) {
        navigate("/app");
    }

    return (
        <Outlet />
    )
};
